import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {CustomAxiosError} from "../../../../../../../../logics/api_config";
import {useApiRentriCalls} from "../../../api-hooks/api_rentri_config";
import {
    IRentriCaratteristichePericolo
} from "../../../../../../../../utils/interfaces/special_wasty/rentri/codifiche/rifiuto/IRentriCaratteristichePericolo";


const useApiGetRentriCaratteristichePericolo = (): UseQueryResult<IRentriCaratteristichePericolo[], CustomAxiosError> => {
    const {get} = useApiRentriCalls()

    async function doGet(): Promise<IRentriCaratteristichePericolo[]> {
        try {
            const response = await get(`/codifiche/v1.0/lookup/caratteristiche-pericolo`);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ["useApiGetRentriCaratteristichePericolo"],
        queryFn: () => doGet(),
    })
};

export default useApiGetRentriCaratteristichePericolo